import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../common/icon';
import { t } from '../../../modules/infra/i18n';
import Timer from './Timer';

const photo = (item) => {
  if (item.photos && item.photos.length > 0) {
    return (<img className="c-avatar-image" src={item.photos[0].thumbnail} alt="" />);
  }

  if (item.type === 'brand') {
    return (<Icon glyph={GLYPHS.brandPointsOnMap} size="medium" className="c-shops-navigation__all-locations" />);
  }

  if (item.type === 'barber') {
    return (<Icon glyph={GLYPHS.barbers} size="medium" />);
  }

  return (<Icon glyph={GLYPHS.pointOnMap} size="medium" />);
};

const ActiveLocation = () => (
  <>
    {t('shops:shop_switcher.active_location')} &middot; <Timer />
  </>
);

const ShopNameSwitcherListItem = props => (
  <li className="c-shops-navigation__list-item">
    <a className="c-shops-navigation__link" onClick={props.onClick}>
      <div className="c-avatar">
        {photo(props.item)}
      </div>
      <div className="c-shop-name">{props.item.alias || props.item.name}</div>
      <div className="c-shop-description">
        {(props.active && props.item.type !== 'brand') ? <ActiveLocation /> : props.item.description}
      </div>
      {props.active && <div className="c-shop-selected-mark">
        <Icon glyph={GLYPHS.selectedShopMark} />
        </div>}
    </a>
  </li>
  );

ShopNameSwitcherListItem.propTypes = {
  onClick: PropTypes.func,
  item: PropTypes.any,
  active: PropTypes.bool,
};

export default ShopNameSwitcherListItem;
